export default __webpack_public_path__ + "static/media/worldline.3f8da4cd.jpg";